<template>
  <div class="upgrade-score-line-manage">
    <h2>专升本分数线管理</h2>
    
    <el-button type="primary" @click="showAddDialog">添加分数线</el-button>
    
    <el-table :data="scoreLineList" style="width: 100%; margin-top: 20px;" border>
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="year" label="年度" width="150"></el-table-column>
      <el-table-column prop="majorName" label="专业名称" width="300"></el-table-column>
      <el-table-column prop="score" label="分数" width="150"></el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="年度">
          <el-input v-model="form.year" placeholder="请输入年度，如：2024"></el-input>
        </el-form-item>
        <el-form-item label="专业名称">
          <el-input v-model="form.majorName" placeholder="请输入专业名称"></el-input>
        </el-form-item>
        <el-form-item label="分数">
          <el-input-number v-model="form.score" :min="0" :max="1000" :precision="2" placeholder="请输入分数"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import upgradeScoreLineApi from '@/api/upgradeScoreLine'

export default {
  name: 'UpgradeScoreLineManage',
  data() {
    return {
      scoreLineList: [],
      dialogVisible: false,
      dialogTitle: '添加分数线',
      isEdit: false,
      form: {
        id: null,
        year: '',
        majorName: '',
        score: null
      }
    }
  },
  mounted() {
    this.loadScoreLineList()
  },
  methods: {
    loadScoreLineList() {
      upgradeScoreLineApi.getList().then(res => {
        if (res.data.code === 200) {
          this.scoreLineList = res.data.data
        }
      })
    },
    showAddDialog() {
      this.dialogTitle = '添加分数线'
      this.isEdit = false
      this.form = {
        id: null,
        year: '',
        majorName: '',
        score: null
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑分数线'
      this.isEdit = true
      this.form = { ...row }
      this.dialogVisible = true
    },
    handleSubmit() {
      const api = this.isEdit ? upgradeScoreLineApi.update : upgradeScoreLineApi.add
      api(this.form).then(res => {
        if (res.data.code === 200) {
          this.$message.success(res.data.message)
          this.dialogVisible = false
          this.loadScoreLineList()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除该分数线吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        upgradeScoreLineApi.delete(id).then(res => {
          if (res.data.code === 200) {
            this.$message.success(res.data.message)
            this.loadScoreLineList()
          } else {
            this.$message.error(res.data.message)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.upgrade-score-line-manage {
  padding: 20px;
}
</style>
